// Single source of truth for partner-facing contact + footer chrome, consumed
// by every portal surface (dashboard footer, brief detail, response form,
// decline, account drawer). No page should hard-code a contact string, phone
// number, copyright line or footer credit — change it here and every page
// updates.
//
// The rule the briefs keep asking for: render ONLY the values that are set. A
// null channel/attribution simply doesn't appear — no "TBC" badge, no empty
// label, no stray credit tab.
export const PORTAL_CONTACT = {
  partnerSupport: {
    // Confirmed partner-facing support channels (Robynne, 2026-07-23). The
    // footer renders "Email us" + "Call us" automatically from whatever is set
    // here; null any channel to drop it everywhere at once.
    email: 'production@fusion-events.com',
    phone: '01234 351707',        // display form
    phoneDial: '+441234351707',   // tel: target, international dial format
    hours: 'Mon–Fri 9am–5pm',
  },
  footer: {
    copyright: '© 2026 Fusion 2K Ltd',
    // DECISION (footer brief A5): "Powered by CORE" is a KEPT, deliberate
    // credit (Robynne, 2026-07-23). Rendered as a styled line in the footer
    // bottom bar. Set to null here to remove it everywhere.
    attribution: 'CORE',
  },
};

// The configured contact channels, in display order, filtered to those set.
// Each entry: { type: 'email' | 'phone', value }.
export function portalContactChannels() {
  const { email, phone } = PORTAL_CONTACT.partnerSupport;
  const channels = [];
  if (email) channels.push({ type: 'email', value: email });
  if (phone) channels.push({ type: 'phone', value: phone });
  return channels;
}
